import React from "react"
import { GridContainer, Grid, CounterLink, Counter, State, Header } from "./styles"

const StaffStats = ({ desktopOnly, mobileOnly, staffCounts, homePage }) => {
  return (
    <GridContainer desktopOnly={desktopOnly} mobileOnly={mobileOnly} homePage={homePage} className="hide-on-print">
      <Grid desktopOnly>
        <Header>My Staff</Header>
      </Grid>
      <Grid>
        <CounterLink to={"/placements/watchlist"}>
          <Counter>{staffCounts?.watchlist_count || 0}</Counter>
          <State>WATCHLIST</State>
        </CounterLink>
      </Grid>
      <Grid>
        <CounterLink to={"/placements/on_review"}>
          <Counter>{staffCounts?.on_review_count || 0}</Counter>
          <State>ON REVIEW</State>
        </CounterLink>
      </Grid>
      <Grid>
        <CounterLink to={"/placements/interviews"}>
          <Counter>{staffCounts?.interviews_count || 0}</Counter>
          <State>INTERVIEWS</State>
        </CounterLink>
      </Grid>
      <Grid>
        <CounterLink to={"/placements/placement_offered"}>
          <Counter>{staffCounts?.offered_count || 0}</Counter>
          <State>OFFERED</State>
        </CounterLink>
      </Grid>
      <Grid>
        <CounterLink to={"/placements/placed"}>
          <Counter>{staffCounts?.hired_count || 0}</Counter>
          <State>HIRED</State>
        </CounterLink>
      </Grid>
    </GridContainer>
  )
}

export default StaffStats
